import React from 'react';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';
import { Autocomplete } from '../../../Autocomplete';

const getSelectedValue = (i, value) =>
  i.isMulti && value ? i.options.filter(opt => value.includes(opt.value)) : i.options.find(opt => opt.value == value);

const Select = ({ classes, i, treeTrace, error, onChange, value, mode }) => {
  const {
    field,
    label,
    options,
    noOptionsMessage,
    direction,
    disabledOnEdit,
    validate,
    disabled,
    isMulti,
    placeholder,
    async,
    defaultOptions,
    loadOptions,
    filterOption,
  } = i;

  return (
    <div className={classes.inputContainer}>
      <p
        style={{ marginBottom: 5, fontWeight: 400 }}
        className={cn(
          classes.inputLabel,
          disabledOnEdit && mode === 'EDIT' && classes.disabledText,
          error && classes.textLabelError,
        )}
      >
        {label}: {!!error && error} <span>({options.length} options)</span>
      </p>
      {/* <div style={{ opacity: 0.5, fontSize: 10 }}>Current number of options: {options.length}</div> */}

      <Autocomplete
        {...i}
        options={options || []}
        disabled={disabled}
        // value={i.options.find(opt => opt.value === value)}
        value={getSelectedValue(i, value)}
        onChange={opt => {
          if (isMulti) {
            onChange(field, opt ? opt.map(o => o.value) : opt, treeTrace, i.onChange);
          } else {
            onChange(field, opt ? opt.value : opt, treeTrace, i.onChange);
          }
        }}
        placeholder={placeholder}
        error={error}
        //
        // ASYNC stuff
        async={async}
        defaultOptions={defaultOptions}
        loadOptions={loadOptions}
        //
        // additional props
        filterOption={filterOption}
      />
    </div>
  );
};

export default withStyles(styles)(Select);
